export const PolicyCancellationSubmissionReasonValue = {
  CUSTOMER_CIRCUMSTANCE: 'CUSTOMER_CIRCUMSTANCE',
  TECHNICAL_ISSUE: 'TECHNICAL_ISSUE',
  AGENT_ERROR: 'AGENT_ERROR',
};

const path = 'POLICY_CANCELLATION.submissionReason';

export const policyCancellationSubmissionReasons = [
  {
    value: PolicyCancellationSubmissionReasonValue.CUSTOMER_CIRCUMSTANCE,
    label: `${path}.customerCircumstance`,
    examples: `${path}.customerCircumstanceExamples`,
  },
  {
    value: PolicyCancellationSubmissionReasonValue.TECHNICAL_ISSUE,
    label: `${path}.technicalIssue`,
    examples: `${path}.technicalIssueExamples`,
  },
  {
    value: PolicyCancellationSubmissionReasonValue.AGENT_ERROR,
    label: `${path}.agentError`,
    examples: `${path}.agentErrorExamples`,
  },
];
